import type { AlternativeGroup, AlternativeItem } from '@/lib/types'

export function availableAlternatives(group: AlternativeGroup): AlternativeItem[] {
  return group.alternativeItems.filter((item) => !item.addonProduct || (item.addonProduct.properties && item.addonProduct.properties.isActive !== false))
}

export function choiceCount(group: AlternativeGroup, selections: Record<string, number>): number {
  return group.alternativeItems.reduce((total, item) => total + (selections[item.name] ?? 0) * (item.countableUsage ?? 1), 0)
}

export function isSingleChoice(group: AlternativeGroup): boolean {
  return !group.isCountable && group.maxChoices === 1 && group.alternativeItems.every((item) => (item.countableUsage ?? 1) === 1)
}

export function changeAlternative(group: AlternativeGroup, selected: Record<string, number>, name: string, count: number): Record<string, number> {
  const next = { ...selected }
  if (count <= 0) {
    delete next[name]
    return next
  }
  if (!availableAlternatives(group).some((item) => item.name === name)) return selected
  if (!Number.isInteger(count) || (!group.isCountable && count > 1)) return selected
  if (isSingleChoice(group)) return { [name]: 1 }
  next[name] = count
  return choiceCount(group, next) <= (group.maxChoices ?? Infinity) ? next : selected
}

export function validAlternativeChoices(group: AlternativeGroup, selected: Record<string, number>): boolean {
  const count = choiceCount(group, selected)
  if (count < (group.minChoices ?? 0) || count > (group.maxChoices ?? Infinity)) return false
  const available = availableAlternatives(group)
  return Object.entries(selected).every(([name, quantity]) => Number.isInteger(quantity) && quantity > 0 && (group.isCountable || quantity === 1) && available.some((item) => item.name === name))
}
